import {
  endPoints,
  leadStatusObj,
  priorityObj,
  propertyStatusObj,
  saleCardVariantObj,
  targetTaskStatusOptionsObj,
  targetTypeObj,
  task,
  taskStatusObj,
  tokenStatusObj,
} from "utils/constants";

const { leadEndPoint } = endPoints;
const {
  statusNew,
  statusActive,
  statusClosedWon,
  statusClosedLost,
  statusDead,
  statusRecycled,
  tokenBooked,
  tokenExtended,
} = leadStatusObj;

const { priorityHigh, priorityLow, priorityNormal, priorityUrgent } =
  priorityObj;

const { taskStatusClosed, taskStatusOpen, taskStatusPending } = taskStatusObj;

const {
  tokenStatusOpen,
  tokenStatusWon,
  tokenStatusLost,
  tokenStatusExpired,
  tokenStatusExtended,
} = tokenStatusObj;

const {
  propertySold,
  propertyAvailable,
  propertyBooked,
  propertyNotAvailable,
} = propertyStatusObj;

const { statusInProgress, statusStopped, statusNotStarted, statusCompleted } =
  targetTaskStatusOptionsObj;

const {
  task: targetTask,
  newLead,
  qualifiedCalls,
  nonQualifiedCalls,
  rawToPolishedLead,
} = targetTypeObj;

export type SimpleObjectType = { [key: string]: string };

export const cardTypes: { [key: string]: string } = {
  lead: "Lead",
  task: "Task",
  token: "Token",
  inventory: "Inventory",
  target: "Staff Target",
  sales: "Sales",
};

export const durationOptions: SimpleObjectType[] = [
  { value: "1-day", label: "1 Day" },
  { value: "1-week", label: "1 Week" },
  { value: "1-month", label: "1 Month" },
  { value: "all", label: "All" },
];

export const durationConversionObj: SimpleObjectType = {
  "1 Day": "1",
  "1 Week": "7",
  "1 Month": "30",
  All: "all",
};

export const durationDefaultValue: string = "All";

export const total: string = "Total";

export const overall: string = "overall";

export const chartTypeOptions: SimpleObjectType[] = [
  { value: "pie-chart", label: "Pie Chart" },
];

export const groupByOptions: { [key: string]: SimpleObjectType[] } = {
  "Pie Chart": [
    { value: "task-by-status", label: "Task By Status" },
    { value: "task-by-priority", label: "Task By Priority" },
    { value: "open-task-per-user", label: "Open Task Per User" },
    {
      value: "open-task-by-priority-per-user",
      label: "Open Task By Priority Per User",
    },
    { value: "lead-by-status", label: "Lead By Status" },
    { value: "lead-by-priority", label: "Lead By Priority" },
    {
      value: "lead-by-status-per-project",
      label: "Lead By Status Per Project",
    },
    {
      value: "lead-by-priority-per-project",
      label: "Lead By Priority Per Project",
    },
    {
      value: "total-leads-per-project",
      label: "Total Leads Per Project",
    },
    {
      value: "lead-by-status-per-source",
      label: "Lead By Status Per Source",
    },
    {
      value: "lead-by-priority-per-source",
      label: "Lead By Priority Per Source",
    },
    {
      value: "total-leads-per-source",
      label: "Total Leads Per Source",
    },
    {
      value: "lead-by-status-per-user",
      label: "Lead By Status Per User",
    },
    {
      value: "lead-by-priority-per-user",
      label: "Lead By Priority Per User",
    },
    {
      value: "total-leads-per-user",
      label: "Total Leads Per User",
    },
  ],
};

export const basedOnOptions: { [key: string]: SimpleObjectType[] } = {
  "Task By Status": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
  ],
  "Task By Priority": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
  ],
  "Open Task Per User": [{ value: "due-date", label: "Due Date" }],
  "Open Task By Priority Per User": [{ value: "due-date", label: "Due Date" }],
  "Lead By Status": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  "Lead By Priority": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  "Lead By Status Per Project": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  "Lead By Priority Per Project": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  "Total Leads Per Project": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  "Lead By Status Per Source": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  "Lead By Priority Per Source": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  "Total Leads Per Source": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  "Lead By Status Per User": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  "Lead By Priority Per User": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  "Total Leads Per User": [
    { value: "created-date", label: "Created Date" },
    { value: "due-date", label: "Due Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
};

export const taskWidgetKeys: any = {
  taskByStatus: {
    "due-date": "task_by_status_due_date",
    "created-date": "task_by_status_created_date",
  },
  taskByPriority: {
    "due-date": "task_by_priority_due_date",
    "created-date": "task_by_priority_created_date",
  },
  taskPerUser: {
    "due-date": "open_task_by_priority_due_date",
  },
  openTaskByPriorityPerUser: {
    "due-date": "open_task_by_priority_due_date",
  },
};

export const leadWidgetKeys: any = {
  leadByStatus: {
    "due-date": "lead_by_status_due_date",
    "created-date": "lead_by_status_created_date",
    "updated-date": "lead_by_status_updated_date",
  },
  leadByPriority: {
    "due-date": "lead_by_priority_due_date",
    "created-date": "lead_by_priority_created_date",
    "updated-date": "lead_by_priority_updated_date",
  },
  leadByStatusPerProject: {
    "due-date": "lead_by_status_due_date",
    "created-date": "lead_by_status_created_date",
    "updated-date": "lead_by_status_updated_date",
  },
  leadByPriorityPerProject: {
    "due-date": "lead_by_priority_due_date",
    "created-date": "lead_by_priority_created_date",
    "updated-date": "lead_by_priority_updated_date",
  },
  totalLeadsPerProject: {
    "due-date": "lead_by_status_due_date",
    "created-date": "lead_by_status_created_date",
    "updated-date": "lead_by_status_updated_date",
  },
  leadByStatusPerSource: {
    "due-date": "lead_by_status_due_date",
    "created-date": "lead_by_status_created_date",
    "updated-date": "lead_by_status_updated_date",
  },
  leadByPriorityPerSource: {
    "due-date": "lead_by_priority_due_date",
    "created-date": "lead_by_priority_created_date",
    "updated-date": "lead_by_priority_updated_date",
  },
  totalLeadsPerSource: {
    "due-date": "lead_by_status_due_date",
    "created-date": "lead_by_status_created_date",
    "updated-date": "lead_by_status_updated_date",
  },
  leadByStatusPerUser: {
    "due-date": "lead_by_status_due_date",
    "created-date": "lead_by_status_created_date",
    "updated-date": "lead_by_status_updated_date",
  },
  leadByPriorityPerUser: {
    "due-date": "lead_by_priority_due_date",
    "created-date": "lead_by_priority_created_date",
    "updated-date": "lead_by_priority_updated_date",
  },
  totalLeadsPerUser: {
    "due-date": "lead_by_status_due_date",
    "created-date": "lead_by_status_created_date",
    "updated-date": "lead_by_status_updated_date",
  },
};

export const keysConversionObj: SimpleObjectType = {
  "Due Date": "due-date",
  "Created Date": "created-date",
  "Updated Date": "updated-date",
  "Task By Status": "taskByStatus",
  "Task By Priority": "taskByPriority",
  "Open Task Per User": "taskPerUser",
  "Open Task By Priority Per User": "openTaskByPriorityPerUser",
  "Lead By Status": "leadByStatus",
  "Lead By Priority": "leadByPriority",
  "Lead By Status Per Project": "leadByStatusPerProject",
  "Lead By Priority Per Project": "leadByPriorityPerProject",
  "Total Leads Per Project": "totalLeadsPerProject",
  "Lead By Status Per Source": "leadByStatusPerSource",
  "Lead By Priority Per Source": "leadByPriorityPerSource",
  "Total Leads Per Source": "totalLeadsPerSource",
  "Lead By Status Per User": "leadByStatusPerUser",
  "Lead By Priority Per User": "leadByPriorityPerUser",
  "Total Leads Per User": "totalLeadsPerUser",
};

export const leadsWidgetLabels: string[] = [
  "Lead By Status",
  "Lead By Priority",
  "Lead By Status Per Project",
  "Lead By Priority Per Project",
  "Total Leads Per Project",
  "Lead By Status Per Source",
  "Lead By Priority Per Source",
  "Total Leads Per Source",
  "Lead By Status Per User",
  "Lead By Priority Per User",
  "Total Leads Per User",
];
export const tasksWidgetLabels: string[] = [
  "Task By Status",
  "Task By Priority",
  "Open Task Per User",
  "Open Task By Priority Per User",
];

export const perResourceKeys: SimpleObjectType = {
  openTaskPerUser: "Open Task Per User",
  openTaskByPriorityPerUser: "Open Task By Priority Per User",
  leadByStatusPerProject: "Lead By Status Per Project",
  leadByPriorityPerProject: "Lead By Priority Per Project",
  totalLeadsPerProject: "Total Leads Per Project",
  leadByStatusPerSource: "Lead By Status Per Source",
  leadByPriorityPerSource: "Lead By Priority Per Source",
  totalLeadsPerSource: "Total Leads Per Source",
  leadByStatusPerUser: "Lead By Status Per User",
  leadByPriorityPerUser: "Lead By Priority Per User",
  totalLeadsPerUser: "Total Leads Per User",
};

export const WidgetStatsTypes: SimpleObjectType = {
  lead: "Lead",
  task: "Task",
};

export const projectSelectionRadioBtns = [
  { key: "all", value: "All" },
  { key: "specific-project", value: "Specific Project" },
];

export const all: string = "All";

export const widgetHeaderLabelObj: SimpleObjectType = {
  "Task By Status": "taskByStatus",
  "Task By Priority": "taskByPriority",
  "Open Task Per User": "taskPerUser",
  "Open Task By Priority Per User": "Username",
  "Lead By Status": "Lead Status",
  "Lead By Priority": "Lead Priority",
  "Lead By Status Per Project": "Project Name",
  "Lead By Priority Per Project": "Project Name",
  "Total Leads Per Project": "Project Name",
  "Lead By Status Per Source": "Source",
  "Lead By Priority Per Source": "Source",
  "Total Leads Per Source": "Source",
  "Lead By Status Per User": "Username",
  "Lead By Priority Per User": "Username",
  "Total Leads Per User": "Username",
};

export const perUser = "per-user";

export const cardTypesRadioBtns = [
  { key: "task", value: "Task" },
  { key: "lead", value: "Lead" },
  { key: "token", value: "Token" },
  { key: "inventory", value: "Inventory" },
  { key: "target", value: "Staff Target" },
  { key: "sales", value: "Sales" },
];

export const leadCardsSearchParamObj = {
  [statusNew]: {
    lead_status: statusNew,
  },
  [statusClosedWon]: {
    lead_status: statusClosedWon,
  },
  [statusActive]: {
    lead_status: statusActive,
  },
  [statusClosedLost]: {
    lead_status: statusClosedLost,
  },
  [statusDead]: {
    lead_status: statusDead,
  },
  [statusRecycled]: {
    lead_status: statusRecycled,
  },
  [tokenBooked]: {
    lead_status: tokenBooked,
  },
  [tokenExtended]: {
    lead_status: tokenExtended,
  },
  [priorityLow]: {
    lead_priority: priorityLow,
  },
  [priorityNormal]: {
    lead_priority: priorityNormal,
  },
  [priorityUrgent]: {
    lead_priority: priorityUrgent,
  },
  [priorityHigh]: {
    lead_priority: priorityHigh,
  },
};

export const taskCardsSearchParamObj = {
  [taskStatusClosed]: {
    task_status: taskStatusClosed,
  },
  [taskStatusOpen]: {
    task_status: taskStatusOpen,
  },
  [taskStatusPending]: {
    task_status: taskStatusPending,
  },

  [priorityLow]: {
    task_priority: priorityLow,
  },
  [priorityNormal]: {
    task_priority: priorityNormal,
  },
  [priorityUrgent]: {
    task_priority: priorityUrgent,
  },
  [priorityHigh]: {
    task_priority: priorityHigh,
  },
};

export const tokenCardsSearchParamObj = {
  [tokenStatusOpen]: {
    token_status: tokenStatusOpen,
  },
  [tokenStatusWon]: {
    token_status: tokenStatusWon,
  },
  [tokenStatusLost]: {
    token_status: tokenStatusLost,
  },
  [tokenStatusExtended]: {
    token_status: tokenStatusExtended,
  },
  [tokenStatusExpired]: {
    token_status: tokenStatusExpired,
  },
};

export const inventoryCardsSearchParamObj = {
  [propertyAvailable]: {
    property_status: propertyAvailable,
  },
  [propertySold]: {
    property_status: propertySold,
  },
  [propertyBooked]: {
    property_status: propertyBooked,
  },
  [propertyNotAvailable]: {
    property_status: propertyNotAvailable,
  },
};

export const targetCardsSearchParamObj = {
  [statusInProgress]: {
    status: statusInProgress,
  },
  [statusStopped]: {
    status: statusStopped,
  },
  [statusNotStarted]: {
    status: statusNotStarted,
  },
  [statusCompleted]: {
    status: statusCompleted,
  },
  [targetTask]: {
    target_type: targetTask,
  },
  [newLead]: {
    target_type: newLead,
  },
  [qualifiedCalls]: {
    target_type: qualifiedCalls,
  },
  [nonQualifiedCalls]: {
    target_type: nonQualifiedCalls,
  },
  [rawToPolishedLead]: {
    target_type: rawToPolishedLead,
  },
};

export const paramsObjForCards: any = {
  Lead: leadCardsSearchParamObj,
  Task: taskCardsSearchParamObj,
  Token: tokenCardsSearchParamObj,
  Inventory: inventoryCardsSearchParamObj,
  "Staff Target": targetCardsSearchParamObj,
  Sales: ({
    user,
    project,
    variant,
  }: {
    user?: string;
    project?: string;
    variant?: string;
  }) => {
    const params: any = {};

    if (
      user &&
      user !== "All"
      // && variant !== saleCardVariantObj.saleAmount
    ) {
      params.createdby_user__id = user?.split(",")[1] || "";
    }

    if (variant === saleCardVariantObj.saleAmount) {
      params.total_sales = "all";
      // params.user_name = user;
    }

    if (project && project !== "All") {
      params.project__project_id = project?.split(",")[1] || "";
    }

    return params;
  },
};

export const groupByKeys: { [key: string]: string } = {
  byStatus: "By Status",
  byPriority: "By Priority",
  none: "None",
};

export const dashboardCardbasedOnOptions: {
  [key: string]: SimpleObjectType[];
} = {
  [cardTypes.task]: [
    { value: "created-date", label: "Created Date" },
    { value: "date-closed", label: "Close Date" },
    { value: "due-date", label: "Due Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  [cardTypes.lead]: [
    { value: "created-date", label: "Created Date" },
    { value: "date-closed", label: "Close Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  [cardTypes.token]: [
    { value: "created-date", label: "Created Date" },
    { value: "date-expiry", label: "Expiry Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  [cardTypes.inventory]: [
    { value: "created-date", label: "Created Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  [cardTypes.target]: [
    { value: "created-date", label: "Created Date" },
    { value: "updated-date", label: "Updated Date" },
  ],
  [cardTypes.sales]: [{ value: "created-date", label: "Created Date" }],
};
